export const fieldNames = {
  startDate: 'startDate',
  endDate: 'endDate',
  addresses: 'addresses',
  dateSetting: 'dateSetting',
  cleanableDateEntity: 'cleanableDateEntity',
  action: 'action',
};

export const dateSettingValueEnum = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  PERIOD: 'period',
};

export const actionsEnum = {
  SET: 'set',
  CLEAR: 'clear',
};
